import { DOCUMENT_TYPE } from '../../../constants/citizenship';

export const SELECT_OPTIONS_TEXT = {
  [DOCUMENT_TYPE.PASSPORT_RF]: 'Паспорт гражданина РФ',
  [DOCUMENT_TYPE.INTERNATIONAL_PASSPORT_RF]: 'Загранпаспорт гражданина РФ',
  [DOCUMENT_TYPE.TEMPORARY_ID]:
    'Временное удостоверение личности гражданина РФ (по форме N 2П)',
  [DOCUMENT_TYPE.FOREIGN_PASSPORT]: 'Паспорт иностранного гражданина',
  [DOCUMENT_TYPE.REFUGEE_ID]: 'Удостоверение беженца',
  [DOCUMENT_TYPE.TEMPORARY_RESIDENT_PERMIT]:
    'Разрешение на временное проживание',
  [DOCUMENT_TYPE.RESIDENCE]: 'Вид на жительство',
  [DOCUMENT_TYPE.DIPLOMATIC_PASSPORT]: 'Дипломатический паспорт',
  [DOCUMENT_TYPE.SERVICE_PASSPORT]: 'Служебный паспорт',
  [DOCUMENT_TYPE.MILITARY_ID]: 'Военный билет',
  [DOCUMENT_TYPE.FOREIGN_NON_CITIZEN_DOC]:
    'Документ, выданный иностранным государством и признаваемый в соответствии с международным договором РФ в качестве документа, удостоверяющего личность лица без гражданства',
  [DOCUMENT_TYPE.RF_NON_CITIZEN_DOC]:
    'Документ, удостоверяющий личность на период рассмотрения заявления о признании гражданином РФ или о приеме в гражданство РФ',
  [DOCUMENT_TYPE.REFUGEE_CONSIDERATION]:
    'Свидетельство о рассмотрении ходатайства о признании беженцем на территории РФ по существу',
  [DOCUMENT_TYPE.TEMPORARY_REFUGEE_PERMIT]:
    'Свидетельство о предоставлении временного убежища на территории РФ',
  [DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF]: 'Свидетельство о рождении РФ',
  [DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL]:
    'Свидетельство о рождении иностранного образца',
  [DOCUMENT_TYPE.OFFICER_ID]: 'Удостоверение личности военнослужащего РФ'
  // [DOCUMENT_TYPE.SEAMAN_PASSPORT_RF]: 'Паспорт моряка РФ',
  // [DOCUMENT_TYPE.REFUGEE_SOLICITATION]:
  //   'Свидетельство о регистрации ходатайства иммигранта о признании его беженцем',
  // [DOCUMENT_TYPE.FOREIGN_ID]:
  //   'Документ, удостоверяющий личность иностранного гражданина',
  // [DOCUMENT_TYPE.NON_CITIZEN_ID]:
  //   'Документ, удостоверяющий личность лица без гражданства',
  // [DOCUMENT_TYPE.PRISON_RELEASE_CERTIFICATE]:
  //   'Справка об освобождении из мест лишения свободы'
};

export const TRANSLATED_DOCUMENTS = [
  DOCUMENT_TYPE.FOREIGN_PASSPORT,
  DOCUMENT_TYPE.FOREIGN_NON_CITIZEN_DOC,
  DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL
];

export const FIELD_NAME = {
  number: 'number',
  dateOfIssue: 'dateOfIssue',
  byWhom: 'byWhom'
};
